import React from 'react';
import config from 'config';
import * as PropTypes from 'prop-types';
import Button from 'components/Button';
import Loading from 'components/Loading';
import dummyAvatar from 'images/avatar-120.png';
import {
  FILE_SIZE_ERROR_MESSAGE,
  PROFILE_IMAGE_ACCEPT,
  PROFILE_MAX_UPLOAD_SIZE,
  serverErrorMessage,
  UNSUPPORT_FILE_TYPE_ERROR_MESSAGE,
} from 'modules/Profile/components/PersonalData/constants';
import { deleteAvatar, uploadAvatar } from 'modules/Profile/services/API';

export default class AvatarComponent extends React.Component {
  state = {
    uploadError: '',
    isLoadingUpload: false,
  };

  fileInputRef = React.createRef();

  clickUploadHandle = () => {
    this.fileInputRef.current.click();
  };

  getValidateFileError(file) {
    const fileName = file.name;
    const fileExt = `.${fileName.split('.').reverse()[0]}`;
    const accept = PROFILE_IMAGE_ACCEPT.split(', ');

    if (file.size > PROFILE_MAX_UPLOAD_SIZE) {
      return FILE_SIZE_ERROR_MESSAGE;
    }

    if (!accept.includes(fileExt)) {
      return UNSUPPORT_FILE_TYPE_ERROR_MESSAGE;
    }
  }

  deletePhoto = async () => {
    this.setState({
      uploadError: '',
      isLoadingUpload: true,
    });
    const { isOk } = await deleteAvatar();
    this.processResultOfRequest(isOk);
  };

  uploadPhoto = async ({ target }) => {
    const file = target.files[0];
    const error = this.getValidateFileError(file);
    if (error) {
      this.setState({
        uploadError: error,
      });
    } else {
      this.setState({
        uploadError: '',
        isLoadingUpload: true,
      });
      const form = new FormData();
      form.append('file', file);
      const { isOk } = await uploadAvatar(form);
      this.processResultOfRequest(isOk);
    }
  };

  processResultOfRequest(isOk) {
    if (isOk) {
      this.setState({
        isLoadingUpload: false,
      });
      this.props.loadAvatar();
    } else {
      this.setState({
        uploadError: serverErrorMessage,
        isLoadingUpload: false,
      });
    }
  }
  render() {
    const { avatar, isReadOnly } = this.props;
    const { isLoadingUpload, uploadError } = this.state;
    const avatarImage = avatar ? avatar : dummyAvatar;
    const avatarButtonLabel = avatar ? 'Сменить фото' : 'Добавить фото';
    const avatarButtonDisabled = isReadOnly || isLoadingUpload || config.isInspectorArm;
    return (
      <div className="profile_wrapper">
        <div className="profile_avatar page_margin10">
          <div className="profile_image">
            <img src={avatarImage} alt="" />
          </div>
          <div className="profile_button">
            <input
              accept={PROFILE_IMAGE_ACCEPT}
              type="file"
              ref={this.fileInputRef}
              style={{ display: 'none' }}
              multiple={false}
              onChange={this.uploadPhoto}
            />
            <Button
              size="medium"
              buttonStyle={{ position: 'relative' }}
              onClick={this.clickUploadHandle}
              isFullWidth={true}
              type="button"
              isDisabled={avatarButtonDisabled}
              hasWrapper={false}
            >
              {isLoadingUpload ? <Loading isLight={true} /> : avatarButtonLabel}
            </Button>
          </div>
        </div>
        {avatar && !config.isInspectorArm ? (
          <div className="profile_link">
            <a onClick={this.deletePhoto}>Удалить фото</a>
          </div>
        ) : null}
        <div className="profile_note">Формат jpeg, jpg, не более 10 кб</div>
        {uploadError && <div className="profile_note red">{uploadError}</div>}
      </div>
    );
  }
}

AvatarComponent.propTypes = {
  avatar: PropTypes.string,
  isReadOnly: PropTypes.bool,
  loadAvatar: PropTypes.func.isRequired,
};
